export const zh = {
    "ConfirmDelete": "确认要删除该记录吗?",
    "OK": "确认",
    "Cancel": "取消",
    "Delete": "删除"
}